import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class DeliveryPackageVolumeCtrl implements IController {
  items: any;

  private totalVolume: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.totalVolume = _.reduce(this.items, (sum, i) => {
      return sum + _.get(i, 'dimensions.cube', 0);
    }, 0);
  };

  $onChanges(changes) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryPackageVolume', {
    bindings: {
      items: '<'
    },
    template: require('./delivery-package-volume.html').default,
    controller: DeliveryPackageVolumeCtrl
  });
